import { ref } from "vue"
import { SessionInfo } from "./personSessionData"
import { appAuth } from "../auth/appAuth"
// import { OktaAuth } from '@okta/okta-auth-js'
import { authProvider } from "./authProviderFactory"
import { useThemeManagerStore } from "@/store/themeManagerStore"
export abstract class routeGuards {
	public static requiresAdmin(to, from, next) {
		if (SessionInfo.currentUserIsAdmin()) {
			next()
		} else {
			next("/")
		}
	}

	public static requiresOktaLogin(to, from, next) {
		//console.log("currentUser", SessionInfo.currentUser())
		if (SessionInfo.currentUser()) {
			next()
		} else if (authProvider.isLoginRedirect?.()) {
			// PKCE callback is in progress — let LoginCallback component handle it
			next()
		} else {
			authProvider.signInWithRedirect().then(async () => {
				const token = await authProvider.getAccessToken()
				console.log("routeGuards token ", token)

				if (token) {
					localStorage.setItem("token", token)

					await appAuth.loginToAppWithOktaToken(token).then((callback) => {
						if (callback != "ok") {
							sessionStorage.setItem("error", callback)
							return false
							//logout()
						} else {
							return next()
						}
					})
					return next()
				} else {
					return false
				}
			})
		}
	}

	public static async requiresOktaLoginWithTheme(to, from, next) {
		//console.log("currentUser", SessionInfo.currentUser())
		if (SessionInfo.currentUser()) {
			// User is already logged in, load their theme before proceeding
			const themeStore = useThemeManagerStore()
			try {
				await themeStore.loadUserThemeOrDefault()
				// console.log("User theme loaded successfully in route guard")
				next()
			} catch (error) {
				console.warn("Failed to load user theme in route guard, proceeding with default:", error)
				next()
			}
		} else if (authProvider.isLoginRedirect?.()) {
			// PKCE callback is in progress — let LoginCallback component handle it
			next()
		} else {
			authProvider.signInWithRedirect().then(async () => {
				const token = await authProvider.getAccessToken()
				console.log("routeGuards token ", token)

				if (token) {
					localStorage.setItem("token", token)

					await appAuth.loginToAppWithOktaToken(token).then(async (callback) => {
						if (callback != "ok") {
							sessionStorage.setItem("error", callback)
							return false
							//logout()
						} else {
							// After successful login, load user theme before navigation
							const themeStore = useThemeManagerStore()
							try {
								await themeStore.loadUserThemeOrDefault()
								console.log("User theme loaded after login in route guard")
							} catch (error) {
								console.warn("Failed to load user theme after login, using default:", error)
							}
							return next()
						}
					})
					return next()
				} else {
					return false
				}
			})
		}
	}
}
